import React from 'react';

import { Link } from '@/app/_i18n/routing';
import { HomepageHeroProps } from '@/app/_blocks/HomepageHeroGraphQL/types';
import { Gutter } from '@/app/_components/Gutter';
import { Media } from '@/app/_components/Media';

import classes from './HomepageHero.module.scss';
import { Page } from '@/payload/payload-types';

export interface HomepageHeroComponentProps {
  homepageHero: HomepageHeroProps;
}

export const HomepageHero: React.FC<HomepageHeroComponentProps> = ({ homepageHero }) => {
  const {
    desktopImage,
    mobileImage,
    tabletImage,
    altText,
    clickAction,
    linkFields,
    desktopImageWidth,
  } = homepageHero;

  const hasTabletImage = !!tabletImage;

  const renderImages = () => {
    if (clickAction === 'link' && linkFields) {
      const refValue = linkFields.reference?.value;
      const href =
        linkFields.type === 'reference' && refValue && typeof refValue === 'object'
          ? `/${(refValue as Page).parentSlug ? (refValue as Page).parentSlug + '/' : ''}${(refValue as Page).slug}/`
          : linkFields.url || '#';

      return (
        <Link
          href={href}
          target={linkFields.newTab ? '_blank' : '_self'}
          rel={linkFields.newTab ? 'noopener noreferrer' : undefined}
          style={{ display: 'block', width: '100%' }}
        >
          <Media
            resource={desktopImage}
            imgClassName={classes.desktopImage}
            alt={altText}
            priority={true}
            unoptimized={true}
          />
          {tabletImage && (
            <Media
              resource={tabletImage}
              imgClassName={classes.tabletImage}
              alt={altText}
              priority={true}
              unoptimized={true}
            />
          )}
          <Media
            resource={mobileImage}
            imgClassName={classes.mobileImage}
            alt={altText}
            priority={true}
            unoptimized={true}
          />
        </Link>
      );
    }

    return (
      <>
        <Media
          resource={desktopImage}
          imgClassName={classes.desktopImage}
          alt={altText}
          priority={true}
          unoptimized={true}
        />
        {tabletImage && (
          <Media
            resource={tabletImage}
            imgClassName={classes.tabletImage}
            alt={altText}
            priority={true}
            unoptimized={true}
          />
        )}
        <Media
          resource={mobileImage}
          imgClassName={classes.mobileImage}
          alt={altText}
          priority={true}
          unoptimized={true}
        />
      </>
    );
  };

  const renderHero = () => {
    return (
      <div className={classes.homepageHero} data-tablet-image-available={hasTabletImage}>
        {renderImages()}
      </div>
    );
  };

  if (desktopImageWidth === 'content-width') {
    return <Gutter className={classes.homepageHeroGutter}>{renderHero()}</Gutter>;
  }

  return <>{renderHero()}</>;
};
